<template>
    <div
        component="Project"
        template="page"
        :class="{ 'small-design': this.$vuetify.breakpoint.sm, 'xs-design': this.$vuetify.breakpoint.xs }"
    >
        <div class="bg">
            <div container="main" type="vertical" padding="0" state="edit-" v-if="!loading">
                <project-header :project="getProject" />

                <v-row block="body" style="z-index: 3">
                    <transition name="fade">
                        <router-view :key="reload" view="detail"></router-view>
                    </transition>
                </v-row>

                <visualizer
                    :use-fade="true"
                    :max-width="true"
                    :color="getColorById(getSelectedCharacter.farba)"
                    name="project"
                />

                <project-send-dialog :project="getProject" />
                <project-status-dialog :project="getProject" />
                <project-approve-dialog :project="getProject" />
                <project-prolong-dialog :project="getProject" />
                <project-gallery-dialog />
                <project-actor-dialog />
                <project-video-dialog />
                <project-video-list-dialog />
            </div>
        </div>

        <div class="director-cut" v-show="showDirectorsCut" :class="{ fadeIn: showDirectorsCut }">
            <iframe v-if="iframeSrc" :key="iframeKey" :src="iframeSrc" width="100%" height="100%"></iframe>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import ProjectSendDialog from '@/components/Project/Dialogs/ProjectSendDialog';
import ProjectStatusDialog from '@/components/Project/Dialogs/ProjectStatusDialog';
import ProjectApproveDialog from '@/components/Project/Dialogs/ProjectApproveDialog';
import ProjectProlongDialog from '@/components/Project/Dialogs/ProjectProlongDialog';
import ProjectHeader from '@/components/Project/ProjectHeader';
import ProjectGalleryDialog from '@/components/Project/Dialogs/ProjectGalleryDialog';
import ProjectActorDialog from '@/components/Project/Dialogs/ProjectActorDialog/ProjectActorDialog';
import ProjectVideoDialog from '@/components/Project/Dialogs/ProjectVideoDialog';
import ProjectVideoListDialog from '@/components/Project/Dialogs/ProjectVideoListDialog/ProjectVideoListDialog';

export default {
    name: 'Project',

    data() {
        return {
            loading: true,
            iframeSrc: '',
            iframeKey: 0,
            reload: 0,
        };
    },

    async created() {
        await this.loadProjectEssentials();
        this.$_eventsSubscribe({
            videoRequestSubmitted: 'projectLoad',
            videoRequestVideoRemoved: 'projectLoad',
            videoRequestVideoUploaded: 'projectLoad',
        });

        if (this.$route.query.dc === 'true') {
            this.loadIframe();
        }
    },

    mounted() {
        this.projectLoad();
    },

    beforeDestroy() {
        this.$_eventsUnsubscribe();
    },

    methods: {
        ...mapActions(['loadProject', 'loadProjectEssentials']),

        async projectLoad() {
            if (this.$route.params.project_id) {
                await this.loadProject(this.$route.params.project_id);
            }
            this.$_eventsDispatch('projectLoaded', this.getProject);
            this.loading = false;
        },

        loadIframe() {
            this.iframeSrc = this.getProject.directorscut_url;
            this.iframeKey++;
        },
    },

    computed: {
        ...mapGetters(['getProject', 'getSelectedCharacter', 'getColorById']),

        showDirectorsCut() {
            if (!this.$route.query.dc) {
                this.projectLoad().then(() => {
                    this.reload += 1;
                });
            } else {
                this.loadIframe();
            }

            return this.$route.query.dc === 'true';
        },
    },

    components: {
        ProjectVideoListDialog,
        ProjectVideoDialog,
        ProjectActorDialog,
        ProjectGalleryDialog,
        ProjectHeader,
        ProjectProlongDialog,
        ProjectApproveDialog,
        ProjectStatusDialog,
        ProjectSendDialog,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Project'] {
    height: 100vh;
    max-height: 100vh;
    min-width: 640px;

    .bg {
        max-width: 1200px;
        position: relative;
        padding-top: 0;

        [component='MenuButton'] {
            position: absolute;
            right: 25px !important;
            left: auto;
        }
    }

    [container='main'] {
        position: inherit;
        max-width: 100%;
        height: 100%;

        & > .row {
            flex: 0 1 auto;
            position: relative;
        }

        & > .row ~ .row {
            flex: 1 1 auto;
        }

        [block='body'] {
            height: 100%;
        }
    }

    .row {
        margin-left: 0;
        margin-right: 0;
    }

    .director-cut {
        position: absolute;
        inset: 0;
        top: 50px;
        z-index: 101;
        background: @white;
        opacity: 0;
        transition: opacity 0.5s ease-in-out 0.3s;

        &.fadeIn {
            opacity: 1;
            box-shadow: 0 -10px 20px -25px #000;
        }

        iframe {
            width: 100%;
            height: 100%;
            border: none;
        }
    }
}
</style>
